<template>
  <div>
    <gg-select
      dense
      outlined
      label="Currently Managing:"
      v-model="selectedAccount"
      :items="subAccountsList"
      item-value="id"
      hide-details
      @change="switchSubAccount"
    >
      <template slot="selection" slot-scope="{ item }">
        {{ item.user }} - {{ item.domain }}
      </template>
      <template slot="item" slot-scope="{ item }">
        {{ item.user }} - {{ item.domain }}
      </template>
    </gg-select>
  </div>
</template>

<script>
export default {
  name: 'SubAccountSwitch',
  props: {
    subAccounts: {
      type: Array,
      default: () => [],
    },
    currentSubAccount: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      subAccount: ''
    }
  },
  computed: {
    subAccountsList () {
      return this.subAccounts
    },
    selectedAccount: {
      get: function () {
        return this.currentSubAccount || this.subAccount
      },
      set: function (newValue) {
        this.subAccount = newValue
      }
    }
  },
  methods: {
    switchSubAccount (selectedSubAccount) {
      this.$emit('sub-account-change', selectedSubAccount)
    }
  },
}
</script>
